import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinChangeEvent, mixinInputEvent, mixinFocusEvent, mixinBlurEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/textarea/textarea';

class FadvTextareaComponent extends mixinChangeEvent(mixinInputEvent(mixinFocusEvent(mixinBlurEvent(mixinFormControl(FadvBaseComponent))))) {
    constructor(el) {
        super(el);
        //The select's name.
        this.name = '';
        //The select's label. Alternatively, you can use the label slot.
        this.label = '';
        this.placeholder = '';
        //The select's help text. Alternatively, you can use the help-text slot.
        this.helpText = '';
        this.valid = false;
        /* This will be true when the control is in an invalid state.
         */
        this.invalid = false;
        /** When true the input will have a floating label, when false the label will be centered able the input */
        this.floating = true;
        /* The autocaptialize attribute of the textarea. */
        this.autocapitalize = undefined;
        /* The autocomplete attribute of the textarea. */
        this.autocomplete = undefined;
        /* The autocorrect attribute of the textarea. */
        this.autocorrect = undefined;
        /* The autofocus attribute of the textarea. */
        this.autofocus = undefined;
        /* The inputmode attribute of the textarea. */
        this.inputmode = undefined;
        /* The maximum length of input that will be considered valid. */
        this.maxlength = undefined;
        /* The minimum length of input that will be considered valid. */
        this.minlength = undefined;
        /* A pattern to validate input against. */
        this.pattern = undefined;
        /* Makes the textarea readonly. */
        this.readonly = false;
        /* Makes the textarea a required field. */
        this.required = false;
        /* Controls how the textarea can be resized. */
        this.resize = 'vertical';
        /* The number of rows to display by default. */
        this.rows = 4;
        /* Enables spell checking on the textarea. */
        this.spellcheck = undefined;
        this.clearable = false;
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => (this.elementRef.nativeElement.value = value));
        this.registerSubscription(this.changed, () => this.reportChange(this.elementRef.nativeElement.value));
        this.registerSubscription(this.inputChanged, () => this.reportChange(this.elementRef.nativeElement.value));
        this.registerSubscription(this.blurred, () => this.onTouched());
    }
    select() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.select();
    }
    setRangeText(replacement, start, end, selectMode) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.setRangeText(replacement, start, end, selectMode);
    }
    setSelectionRange(selectionStart, selectionEnd, selectionDirection) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
}
FadvTextareaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvTextareaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTextareaComponent, selector: "fadv-textarea", inputs: { value: "value", disabled: "disabled", variant: "variant", name: "name", label: "label", placeholder: "placeholder", helpText: "helpText", valid: "valid", invalid: "invalid", floating: "floating", pill: "pill", autocapitalize: "autocapitalize", autocomplete: "autocomplete", autocorrect: "autocorrect", autofocus: "autofocus", inputmode: "inputmode", maxlength: "maxlength", minlength: "minlength", pattern: "pattern", readonly: "readonly", required: "required", resize: "resize", rows: "rows", spellcheck: "spellcheck", clearable: "clearable", characterCount: "characterCount" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed", inputChanged: "inputChanged" }, providers: [createFormControlProvider(FadvTextareaComponent)], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "placeholder", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "floating", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "autocapitalize", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "autocomplete", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "autocorrect", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "autofocus", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "inputmode", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "maxlength", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "minlength", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "pattern", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "readonly", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "resize", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "rows", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "spellcheck", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "clearable", void 0);
__decorate([
    Forward()
], FadvTextareaComponent.prototype, "characterCount", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-textarea',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvTextareaComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { variant: [{
                type: Input
            }], name: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], helpText: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], floating: [{
                type: Input
            }], pill: [{
                type: Input
            }], autocapitalize: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], autocorrect: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], inputmode: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], minlength: [{
                type: Input
            }], pattern: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], resize: [{
                type: Input
            }], rows: [{
                type: Input
            }], spellcheck: [{
                type: Input
            }], clearable: [{
                type: Input
            }], characterCount: [{
                type: Input
            }] } });

class FadvTextareaModule {
}
FadvTextareaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvTextareaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaModule, declarations: [FadvTextareaComponent], imports: [FadvCommonModule], exports: [FadvTextareaComponent] });
FadvTextareaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvTextareaComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvTextareaComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvTextareaComponent, FadvTextareaModule };
